import React, { Fragment } from 'react';
import Select from 'react-select';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import {
	VALUE_COLOR_WIDGET_TYPES,
} from '../layout/webDashboardConstants';
import CreateDatastream from './CreateDatastream';

const WidgetDatastreamSelectorSettings = ({
	edit,
	setEdit,
	t,
	validDatastreams,
	selectedDatastream,
	devices,
	deviceSelectOptions,
	deviceDatastream,
	setDeviceDatastream,
	setAddDatastream,
	findDatastreamById,
	stripDatastreamManagedProps,
	clampToMinMax,
	applyDatastreamDefaultColors,
	remapColorStopsForDatastream,
	getDeviceTemplateSignature,
	themeColorKey,
	themeColorValue,
}) => (
(validDatastreams?.length > 0) && edit.type !== 'fan'&& edit.type !== 'text-title' && edit.type !== ENVIRONMENTAL_STATUS_WIDGET_TYPE ? (
												<Fragment>
													<div className='form-item'>
														<label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.datastreamLabel}</label>
															<Select
																classNamePrefix="react-select"
															onChange={selectedOption => {
																const ds = findDatastreamById(
																	validDatastreams,
																	selectedOption ? selectedOption.value : null,
																);
															const newProps = stripDatastreamManagedProps(edit.props, edit.type);
																Object.keys(newProps).forEach((key) => {
																	if (Object.keys(ds || {}).includes(key) && !key.toLowerCase().includes('color')) {
																		newProps[key] = ds[key];
																}
									if (key === 'value') {
										newProps[key] = clampToMinMax(ds?.defaultValue, ds, newProps);
									}
																});
																const datastreamProps = applyDatastreamDefaultColors(newProps, edit.type, ds);
																if (VALUE_COLOR_WIDGET_TYPES.includes(edit.type)) {
																	const activeStops = themeColorValue(datastreamProps, 'colors', []);
																	datastreamProps[themeColorKey('colors')] = ds
																		? remapColorStopsForDatastream(activeStops, selectedDatastream, ds)
																		: [];
																	if (edit.type === 'label') {
																		const activeShadowStops = themeColorValue(datastreamProps, 'labelShadowColors', []);
																		datastreamProps[themeColorKey('labelShadowColors')] = ds
																			? remapColorStopsForDatastream(activeShadowStops, selectedDatastream, ds)
																			: [];
																	}
																}
																setEdit({
																	...edit,
																	dataId: selectedOption ? (ds?.id ?? null) : null,
																	dataPin: selectedOption ? (ds?.pin ?? null) : null,
																	title: ds?.name || '',
																	transparentBackground: false,
																	props: datastreamProps
																});
															}} options={validDatastreams.map(ds => ({ label: ds.name + ' [' + ds.pin + ']', value: ds.id }))}
															value={validDatastreams.map(ds => ({ label: ds.name + ' [' + ds.pin + ']', value: ds.id })).find(ds => String(ds.value) === String(selectedDatastream?.id ?? edit.dataId)) || null}
															isClearable={true}
														/>
													</div>
													<CreateDatastream onSelect={(cat) => setAddDatastream({
														edit: true,
														pinCategory: cat
													})} />
												</Fragment>
											) :
												((devices?.length > 0) && Array.isArray(devices)) && edit.type !== 'fan' ? (
													<div>

														<div className='form-item'>
															<label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.deviceLabel}</label>
															<Select
																classNamePrefix="react-select"
																options={deviceSelectOptions}
																value={deviceSelectOptions.find(device => device.value === edit.deviceId) || null}
																onChange={selectedOption => {
																	const nextDeviceId = selectedOption ? Number(selectedOption.value) : 0;
																	const nextDevice = (devices || []).find(device => Number(device?.id) === nextDeviceId);
																	const nextDeviceDatastreams = ((nextDevice?.template?.datastreams || []).filter(ds => ds));

																	setDeviceDatastream(nextDeviceDatastreams);
																	setEdit(prev => {
																		const previousDevice = (devices || []).find(device => Number(device?.id) === Number(prev.deviceId));
																		const previousTemplateSignature = getDeviceTemplateSignature(previousDevice);
																		const nextTemplateSignature = getDeviceTemplateSignature(nextDevice);
																		const hasSameTemplate = previousTemplateSignature !== ''
																			&& nextTemplateSignature !== ''
																			&& previousTemplateSignature === nextTemplateSignature;
																		const keepSelectedDatastream = hasSameTemplate
																			&& nextDeviceDatastreams.some(ds => Number(ds?.id) === Number(prev.dataId));

																		return {
																			...prev,
																			deviceId: nextDeviceId,
																			dataId: keepSelectedDatastream ? prev.dataId : null,
																			dataPin: keepSelectedDatastream ? prev.dataPin : null
																		};
																	});
																}}
																isClearable={true}
															/>
														</div>

														{((deviceDatastream?.length > 0) && Array.isArray(deviceDatastream)) ?
															<div className='form-item'>
																<label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.datastreamLabel}</label>
																<Select
																	key={`ds-${edit.deviceId}-${getDeviceTemplateSignature((devices || []).find(device => Number(device?.id) === Number(edit.deviceId)))}`}
																	classNamePrefix="react-select"
																	onChange={selectedOption => {
																		const ds = findDatastreamById(
																			deviceDatastream,
																			selectedOption ? selectedOption.value : null,
																		);

																const newTitle = ds?.name || '';

																const newProps = stripDatastreamManagedProps(edit.props, edit.type);
																Object.keys(newProps).forEach((key) => {
																		if (Object.keys(ds || {}).includes(key) && !key.toLowerCase().includes('color')) {
																			newProps[key] = ds[key];
																		}
													if (key === 'value') {
														newProps[key] = clampToMinMax(ds?.defaultValue, ds, newProps);
													}
																		});
																		const datastreamProps = applyDatastreamDefaultColors(newProps, edit.type, ds);
																		if (VALUE_COLOR_WIDGET_TYPES.includes(edit.type)) {
																			const activeStops = themeColorValue(datastreamProps, 'colors', []);
																			datastreamProps[themeColorKey('colors')] = ds
																				? remapColorStopsForDatastream(activeStops, selectedDatastream, ds)
																				: [];
																			if (edit.type === 'label') {
																				const activeShadowStops = themeColorValue(datastreamProps, 'labelShadowColors', []);
																				datastreamProps[themeColorKey('labelShadowColors')] = ds
																					? remapColorStopsForDatastream(activeShadowStops, selectedDatastream, ds)
																					: [];
																			}
																		}
																		setEdit({
																			...edit,
																			dataId: selectedOption ? (ds?.id ?? null) : null,
																			dataPin: selectedOption ? (ds?.pin ?? null) : null,
																			title: newTitle,
																			transparentBackground: false,
																			props: datastreamProps
																		});
																	}} options={deviceDatastream.map(ds => ({ label: ds.name + ' [' + ds.pin + ']', value: ds.id }))}
																	value={deviceDatastream.map(ds => ({ label: ds.name + ' [' + ds.pin + ']', value: ds.id })).find(ds => String(ds.value) === String(selectedDatastream?.id ?? edit.dataId)) || null}
																	isClearable={true}
																/>
															</div> : null}

													</div>
												) : (!(((devices?.length > 0) && Array.isArray(devices))) && edit.type !== 'fan'&& edit.type !== 'text-title' ? <CreateDatastream onSelect={(cat) => setAddDatastream({
													edit: true,
													pinCategory: cat
												})} /> : null)
);

export default WidgetDatastreamSelectorSettings;
